export default __webpack_public_path__ + "static/tag-do-3-light-33dd9473dcdb627e249246d0c98853c5.png";